import DataTable from "@shared/ui/data-table/DataTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledSystem } from "./systems.styled";
import { useSystemOptions } from "./systems.data";
import { useSystemStructures } from "./useSystemStructures";
import { useSystemsBrowse } from "./useSystemsBrowse";
import { useSystemsNavigation } from "./useSystemsNavigation";

function Systems() {
  const theme = useTheme();
  const { tableStructure } = useSystemStructures();
  const browse = useSystemsBrowse();
  const navigation = useSystemsNavigation();
  const systemOptions = useSystemOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledSystem>
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          searchForm={browse.accountSearchForm}
          onResetSearch={browse.reset}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={systemOptions}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledSystem>
  );
}

export default Systems;
